import { defineStore } from 'pinia'
import { useAsyncRequest } from '@/composables/useAsyncRequest'

import { useCartStore } from '@/stores/cart'

export const useRiskInsuranceStore = defineStore('riskInsurance', () => {
    const { loading, error, request } = useAsyncRequest()
    const cart = useCartStore()

    // meta from API
    const insurance = ref(null)

    const riskInsuranceCondition = computed(() => {
        return (cart.cartConditions || []).find((c) => c?.name === 'RISK_INSURANCE')
    })

    const applied = computed(() => {
        if (riskInsuranceCondition.value) return true
        return !!insurance.value?.applied
    })

    const featureEnabled = computed(() => !!insurance.value?.enabled)

    const loadMeta = async () => {
        const response = await request('get', '/api/cart/risk-insurance/meta')
        insurance.value = response
        return response
    }

    const toggle = async (value) => {
        await request('post', '/api/cart/risk-insurance', {
            enabled: !!value
        })

        await cart.loadCart({ force: true })
        await loadMeta() // ✅ keeps amount + applied updated
    }

    return {
        insurance,
        featureEnabled,
        applied,
        riskInsuranceCondition,
        loadMeta,
        toggle,
        loading,
        error
    }
})
